module.exports = __webpack_public_path__ + "img/lezhi03.e178b526.png";